// extracted by mini-css-extract-plugin
export default {"root":"Table_root__D9mXm","description":"Table_description__fndzW"};